import { PublicKey } from "@solana/web3.js";
import { get_nft_api_rec } from "./api";
import { NftDataType } from "./types";

export const fetchCNFTsInWallet = async (walletAddress: PublicKey) => {
  const endpoint = `https://mainnet.helius-rpc.com/?api-key=${process.env.NEXT_PUBLIC_HELIUS_API}`;
  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: "text",
        jsonrpc: "2.0",
        method: "getAssetsByOwner",
        params: {
          ownerAddress: walletAddress.toBase58(),
          page: 1,
          limit: 1000,
          options: {
            showUnverifiedCollections: false,
            showCollectionMetadata: false,
            showGrandTotal: false,
            showFungible: false, // Only NFT assets
            showNativeBalance: false,
            showInscription: false,
            showZeroBalance: false,
          },
          sortBy: {
            sortBy: "created",
            sortDirection: "asc",
          },
        },
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`Error response from Helius API: ${errorText}`);
      throw new Error(
        `Failed to fetch NFTs: ${response.status} ${response.statusText}`
      );
    }

    const rpcAssetList = await response.json();

    const filtered = rpcAssetList.result.items.filter(
      (cnft: { content: { metadata: { symbol: string } } }) =>
        cnft.content.metadata.symbol == "BOOB"
    );

    const holderAccount: NftDataType[] = [];

    await Promise.allSettled(
      filtered.map(
        async (holder: {
          creators: any[];
          content: {
            metadata: { symbol: string; name: string };
            json_uri: string;
          };
          authorities: any[];
          id: any;
        }) => {
          try {
            let creator = "";
            if (holder.creators.length) {
              for (let i = 0; i < holder.creators.length; i++) {
                if (holder.creators[i].verified == true) {
                  creator = holder.creators[i].address;
                  break;
                }
              }

              if (
                holder.content.metadata.symbol === "BOOB" ||
                holder.content.metadata.name.startsWith("Boobies") ||
                holder.authorities.find(
                  (authority: { address: string }) =>
                    authority.address ===
                    "FEgtsEAf5EoWruZQGEQNrBT1AMMUQo6ArWpsh9rdjctp"
                ) ||
                holder.creators.find(
                  (creator: { address: { toString: () => string } }) =>
                    creator.address.toString() ==
                    "EKACoAbe94V2zMUK9MFY5gqAaZXLD1drdXrrRPEB4ceJ"
                )
              ) {
                const res = await get_nft_api_rec(holder.content.json_uri);

                holderAccount.push({
                  ...res,
                  mint: holder.id,
                  creator: creator,
                });
              }
            }
          } catch (e) {
            console.error(`Error occurred for NFT ${holder.id}: ${e}`);
          }
        }
      )
    );
    return holderAccount;
  } catch (error) {
    console.error("Error in fetchCNFTsInWallet:", error);
    throw error;
  }
};
